import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const FavoriteIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Favorite",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "m17.11 3.44 2.51 7.74c.16.47.6.79 1.1.79h8.13c.63 0 1.15.51 1.15 1.14 0 .37-.18.72-.48.94l-6.58 4.79c-.4.29-.57.81-.42 1.28l2.51 7.73a1.144 1.144 0 0 1-1.76 1.29l-6.58-4.78c-.4-.29-.95-.29-1.35 0l-6.58 4.78A1.138 1.138 0 0 1 7 27.86l2.51-7.73c.15-.47-.02-.99-.42-1.28l-6.58-4.79a1.15 1.15 0 0 1-.26-1.6c.22-.3.57-.48.94-.48h8.16c.5 0 .94-.32 1.1-.79l2.51-7.74c.2-.6.84-.93 1.45-.74.35.11.62.39.74.74Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "m15.86 26.18 9.19 4.07L24 20.26l6.72-7.47-9.83-2.08L15.86 2l-5.03 8.71L1 12.79l6.72 7.47-1.05 9.99z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M25.05 31.4c-.16 0-.31-.03-.46-.1l-8.73-3.86-8.73 3.86a1.14 1.14 0 0 1-1.6-1.16l1-9.48-6.38-7.11c-.27-.3-.36-.73-.24-1.12s.45-.68.85-.76l9.33-1.97 4.78-8.27c.41-.71 1.57-.71 1.98 0l4.77 8.27 9.33 1.97c.4.08.72.38.85.76s.04.81-.24 1.12l-6.38 7.1 1 9.48a1.135 1.135 0 0 1-1.13 1.26Zm-9.19-6.36c.16 0 .32.03.46.1l7.38 3.27-.84-8.02c-.03-.32.07-.64.29-.88l5.4-6-7.89-1.67c-.32-.07-.59-.27-.75-.55l-4.04-7-4.04 7c-.16.28-.44.48-.75.55l-7.89 1.67 5.4 6c.22.24.32.56.29.88l-.84 8.02 7.38-3.27c.15-.07.3-.1.46-.1Z"
      })]
    })
  }));
};
FavoriteIcon.displayName = 'FavoriteIcon';